import {
  callApi
} from "./Api";

export const GET_TAGS_TOTAL = 'GET_TAGS_TOTAL';
export const GET_CLIENTS_TREE = 'GET_CLIENTS_TREE';
export const TAGS_SEARCH = 'TAGS_SEARCH';
export const ALL_TAGS_SEARCH = 'ALL_TAGS_SEARCH';

export const getTagsTotal = () => (dispatch, getState) => {
  const url = 'clients/tag/stats';
  callApi(dispatch, getState, GET_TAGS_TOTAL, url);
}

export const getClientTree = (obj) => (dispatch, getState) => {
  const url = 'clients/tree';
  callApi(dispatch, getState, GET_CLIENTS_TREE, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}

export const tagsSearch = (obj) => (dispatch, getState) => {
  const url = 'clients/tags/search';
  callApi(dispatch, getState, TAGS_SEARCH, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}

export const tagsAllSearch = (obj) => (dispatch, getState) => {
  const url = 'clients/tags/search';
  callApi(dispatch, getState, ALL_TAGS_SEARCH, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}




// WEBPACK FOOTER //
// ./src/actions/TagInfo.js